import React from 'react';
import { Button } from '@apia/theme';

export interface IAccordionElementButton {
  expandedIcons: React.ReactNode;
  id: string;
  isExpanded: boolean;
  onClick: React.MouseEventHandler;
  title: string;
  children?: React.ReactNode;
}

const AccordionElementButton = ({
  expandedIcons,
  id,
  isExpanded,
  onClick,
  title,
  children,
}: IAccordionElementButton) => {
  return (
    <Button
      type="button"
      {...window.getVariant('buttons.accordion')}
      title={title}
      id={`section_${id}`}
      aria-label={title}
      aria-expanded={isExpanded}
      aria-controls={`${id}_content`}
      onClick={onClick}
      onKeyDown={React.useCallback<React.KeyboardEventHandler>(
        (ev) => {
          if (ev.key.toLowerCase() === 'c' && ev.ctrlKey) {
            void navigator.clipboard.writeText(title);
          }
        },
        [title],
      )}
      className="toggleAccordionElement"
    >
      <span>{children ?? title}</span>
      {expandedIcons}
    </Button>
  );
};

export default React.memo(AccordionElementButton);
